import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../../../core/services/general.service';
import { MobileWebViewService } from '../../../core/services/mobile-web-view.service';
import { ScreenManagerService } from '../../../core/services/screen-manager.service';
import { AppConfig } from '../../../shared/config/app-config';

@Component({
	selector: 'app-need-help-section',
	templateUrl: './need-help-section.component.html',
	styleUrls: ['./need-help-section.component.scss'],
})
export class NeedHelpSectionComponent implements OnInit {
	isMobile: any = false;
	canShowHelp: boolean;

	constructor(
		private mobileService: MobileWebViewService,
		private router: Router,
		private generalService: GeneralService,
		private screenManagerService: ScreenManagerService,
		private config: AppConfig
	) {}

	ngOnInit(): void {
		this.isMobile = this.screenManagerService.isMobile();
		this.canShowHelp = this.config.SHOW_ONBOARDING_SUPPORT;
		this.screenManagerService.isMobile$.subscribe((isMobile) => {
			this.isMobile = isMobile;
		});
	}

	openSupport() {
		if (this.isMobile || this.mobileService.isMobileWebViewUser()) {
			this.router.navigateByUrl('/need-help');
		} else {
			const params = { needHelp: true };
			this.generalService.callNeedHelpObervable(params);
		}
	}
}
